module.exports = __webpack_public_path__ + "media/images/icon__arrow-left-5efbc03f63e30b74034fe37b4c037c6c.png";